import { render } from "./DefaultLayout.vue?vue&type=template&id=49983d79&bindings={\"isSidebarOpen\":\"setup\",\"toggleSidebar\":\"setup\",\"onLogout\":\"setup\",\"isLoading\":\"setup\"}"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"
script.render = render

export default script